var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -2 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m10.803 18.55.793.793a.853.853 0 0 0 1.21 0l6.942-6.939a.853.853 0 0 0 0-1.21l-6.942-6.942a.853.853 0 0 0-1.21 0l-.793.793a.86.86 0 0 0 .014 1.224l4.303 4.1H4.857a.855.855 0 0 0-.857.857v1.143c0 .475.382.857.857.857H15.12l-4.303 4.1a.85.85 0 0 0-.014 1.224",
    clipRule: "evenodd"
  })));
};
export default SvgArrowRight;